<template>
  <div>
    <!-- <h1 v-text="app.version"></h1> -->
    <v-card flat class="blueCard">
      <v-card-title class="d-flex pa-2">
        <div
          class="d-flex flex-column flex-sm-row align-start justify-start mb-1 width100p"
        >
          <div class="d-flex flex-row">
            <div style="width: 100px">
              <v-img
                src="https://www.eyedock.com/images/menu_icons/oblique_icon.svg"
                contain
                max-height="60"
              />
            </div>

            <div>
              <div class="text-h5">Oblique Cross Cylinders</div>
              <div class="caption">
                <a href="/documentation/oblique-cross-cyls"
                  >Calculator Documentation

                  <v-icon x-small color="primary" class="mx-1"
                    >mdi-open-in-new</v-icon
                  ></a
                >
              </div>
            </div>
          </div>
          <v-spacer class="d-none d-sm-flex"></v-spacer>

          <div class="d-sm-flex flex-row flex-wrap align-center mt-2 width100p">
            <v-spacer class="d-none d-sm-flex"></v-spacer>
            <rx-paster
              class="mx-2 my-2 my-sm-0"
              buttonText="Parse from Text"
              buttonColor="#FFF"
              :params="['small', 'block']"
              :types="['rx']"
              :imageIcon="true"
              :rxReturnOptions="[
                { label: 'Contact Lens Power', value: 'cl' },
                { label: 'Over Refraction', value: 'or' },
              ]"
              @pasted="pasted($event)"
            >
            </rx-paster>

            <vertex-and-round-dialog
              class="mx-2 my-2 my-sm-0"
              :params="['small', 'block']"
              buttonColor="#FFF"
              @change="
                round = $event.round;
                vertexDistance = $event.vertexDistance;
              "
              :round_ext="round"
              :vertexDistance_ext="vertexDistance"
            ></vertex-and-round-dialog>

            <div class="mx-2 my-2 my-sm-0">
              <v-btn
                small
                depressed
                color="#FFF"
                @click="clearForm()"
                :block="isMobile"
              >
                <v-icon color="red" class="mr-1" small>mdi-cancel</v-icon>Clear
                Form</v-btn
              >
            </div>
          </div>
        </div>

        <!-- <v-spacer class="d-none d-sm-flex"></v-spacer> -->
      </v-card-title></v-card
    >
    <!-- <p>{{ rxObjects }}</p>
    <p>{{ clObjects }}</p> -->

    <div
      class="d-flex flex-column flex-sm-row flex-md-column flex-wrap justify-sm-space-around"
    >
      <v-card
        v-for="eye in ['od', 'os']"
        :key="eye"
        class="my-2"
        flat
        :class="[eye + 'Background', eye + 'Border']"
        :style="eyeCardStyle"
        min-width="250"
      >
        <v-card-title
          class="d-block d-sm-none text-center"
          :class="eye + 'HeaderBackground'"
          >{{ eye | eyeText }} Eye</v-card-title
        >
        <v-card-text
          class="d-flex flex-column flex-md-row pa-2 justify-space-around"
        >
          <!-- <div class="sideways title">{{ eye | eyeText }} Eye</div> -->
          <v-card
            class="text-center"
            :class="[
              isMobile
                ? 'transparentCard_mobile'
                : `transparentCard ${eye}Border`,
            ]"
            flat
          >
            <div class="overline cardLabel" v-if="!isMobile">
              {{ eye.toUpperCase() }} Contact Lens
              <v-tooltip
                v-if="rotation[eye] && Math.abs(rotation[eye]) > 30"
                open-on-click
                open-on-hover
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="warning" v-bind="attrs" v-on="on" small>
                    mdi-alert
                  </v-icon>
                </template>
                <span
                  >That rotation seems excessive. <br />Perhaps consider another
                  toric brand/design?
                </span></v-tooltip
              >
            </div>

            <optical-cross-image
              :dimensions="90"
              :fullWidth="isMobile"
              :obj="clObjects[eye]"
              type="cl"
              class="mx-auto"
              :showAxisLine="true"
              :canRotate="true"
              :lensRotation="rotation[eye]"
              :showMeridianLabels="false"
              @rotation="rotationChange(eye, $event)"
            >
              <template v-slot:moreStuff>
                <!-- <rx-parser
                  triggerTitle="Add CLs"
                  :editTriggerTitle="prettyString(clObjects[eye])"
                  :icon="null"
                  :editIcon="true"
                  buttonColor="primary"
                  :initialRxObjects="clObjects"
                  :showAdd="false"
                  :showVertex="false"
                  title="Contact Lens Rxs"
                  rxType="cl"
                  :textTrigger="true"
                  :smallText="false"
                  @rxChange="parserChange($event, 'cl')"
                ></rx-parser> -->
                <rx-input
                  :eye="eye"
                  :placeholder="eye.toUpperCase() + ' Contact Lens Rx'"
                  :rxString="clStrings[eye]"
                  :showVertexed="false"
                  :showRxCyl="false"
                  :showMoreInfo="false"
                  :noMessages="true"
                  style="width: 95%"
                  class="mx-auto"
                  @rxChange="clObjects[eye] = $event"
                  :tabindex="eye == 'od' ? 1 : 3"
                />
              </template>
            </optical-cross-image>

            <!--       :showCaption="true" -->
          </v-card>
          <v-card
            class="text-center"
            :class="[
              isMobile
                ? 'transparentCard_mobile'
                : `transparentCard ${eye}Border`,
            ]"
            flat
          >
            <div class="overline cardLabel" v-if="!isMobile">
              {{ eye.toUpperCase() }} Overrefraction
            </div>
            <optical-cross-image
              :dimensions="90"
              :obj="vertexedOR[eye]"
              :showLens="false"
              :showEyepiece="true"
              class="mx-auto"
              :showMeridianLabels="false"
              v-if="!isMobile"
            >
              <!-- <template v-slot:moreStuff> </template> -->
            </optical-cross-image>
            <rx-input
              :eye="eye"
              :placeholder="eye.toUpperCase() + ' Over-refraction'"
              :rxString="rxStrings[eye]"
              :showVertexed="true"
              :showRxCyl="false"
              :showMoreInfo="false"
              :noMessages="true"
              style="width: 95%"
              class="mx-auto"
              :class="{ 'mt-4': isMobile }"
              @rxChange="rxObjects[eye] = $event"
              :tabindex="eye == 'od' ? 2 : 4"
            />

            <v-fade-transition>
              <div class="caption" v-if="vertexedOR[eye]">
                {{ prettyString(vertexedOR[eye], round) }} (vertexed)
              </div>
            </v-fade-transition>
          </v-card>
          <v-card
            class="text-center"
            :class="[
              isMobile
                ? 'transparentCard_mobile'
                : `transparentCard ${eye}Border`,
            ]"
            flat
          >
            <div class="overline cardLabel">{{ eye.toUpperCase() }} Result</div>
            <optical-cross-image
              :dimensions="90"
              :obj="resultRx[eye]"
              class="mx-auto"
              :showAxisLine="true"
              :lensRotation="rotation[eye]"
              :showMeridianLabels="false"
              v-if="!isMobile"
            >
              <!-- <template v-slot:moreStuff>
             
              </template> -->
            </optical-cross-image>
            <div class="resultText">
              <span v-if="resultRx[eye]">{{
                prettyStringMinus(resultRx[eye], round)
              }}</span>
              <span v-else>Calculation Result</span>
            </div>
          </v-card>
          <v-card
            :class="[
              isMobile
                ? 'transparentCard_mobile'
                : `transparentCard ${eye}Border`,
            ]"
            flat
            :loading="loadingBrandPowers[eye]"
          >
            <div class="overline cardLabel text-center">
              {{ eye.toUpperCase() }} Closest Available
              <v-btn
                v-if="clBrandObj[eye]"
                icon
                color="primary"
                class="ml-2"
                x-small
                @click="clBrandObj[eye] = null"
                ><v-icon>mdi-close-circle</v-icon></v-btn
              >
            </div>
            <v-card-text>
              <div class="">
                <v-fade-transition>
                  <div class="mt-2" v-if="!clBrandObj[eye]">
                    <div
                      class="caption my-2"
                      :style="!isMobile ? 'height: 109px' : ''"
                    >
                      Identify the toric brand to see the closest available
                      powers for your result.
                    </div>
                    <autocomplete-all-2
                      action="object"
                      onlyModule="CL"
                      onlyType="PRODUCT"
                      moreParams="groups=TORIC"
                      @selected="updateClBrand($event, eye)"
                      style="width: 95%"
                      label="Toric Brand?"
                      :tabindex="-1"
                    ></autocomplete-all-2>
                    <v-btn
                      text
                      small
                      color="primary"
                      v-if="!clBrandObj[eye] && clBrandObj[otherEye(eye)]"
                      @click="updateClBrand(clBrandObj[otherEye(eye)], eye)"
                      class="my-2"
                      :tabindex="-1"
                      >{{ eye }} = {{ otherEye(eye) }}
                    </v-btn>
                  </div>
                  <div v-else class="d-flex flex-column">
                    <div class="font-weight-bold">
                      <div class="d-flex flex-row">
                        <div class="pr-2">
                          {{ clBrandObj[eye].name }}

                          <!-- clPowerDialog info button (i) -->
                          <cl-power-dialog
                            :lensId="clBrandObj[eye].itemId"
                            :lensName="clBrandObj[eye].name"
                            :image="imgPath + clBrandObj[eye].image"
                          >
                            <div class="overline">Suggested Lens</div>
                            <trial-suggestion-card
                              v-if="!brandPowerDirty[eye]"
                              class="my-1"
                              :data="clBrandPowerObj[eye]"
                              :eye="eye"
                              :showWarning="true"
                            ></trial-suggestion-card>
                          </cl-power-dialog>
                        </div>
                        <v-img
                          v-if="clBrandObj[eye].image"
                          :src="imgPath + clBrandObj[eye].image"
                          contain
                          max-height="30"
                          max-width="70"
                          class="pl-2 mx-auto"
                        />
                      </div>
                    </div>

                    <div v-if="clBrandPowerObj[eye]">
                      <trial-suggestion-card
                        v-if="!brandPowerDirty[eye]"
                        class="my-1"
                        :data="clBrandPowerObj[eye]"
                        :eye="eye"
                        :succinct="true"
                        :showWarning="true"
                      ></trial-suggestion-card>
                      <v-btn
                        v-else
                        @click="callPowerApi(eye)"
                        class="mt-2"
                        x-small
                        rounded
                        outlined
                        color="primary"
                        depressed
                        ><v-icon class="mr-2" x-small>mdi-reload</v-icon
                        >Reload</v-btn
                      >
                    </div>
                    <v-btn
                      v-else-if="resultRx[eye]"
                      @click="callPowerApi(eye)"
                      class="mt-2"
                      x-small
                      rounded
                      outlined
                      color="primary"
                      depressed
                      ><v-icon class="mr-2" x-small>mdi-download</v-icon>Load
                      Closest Powers</v-btn
                    >
                  </div>
                </v-fade-transition>
                <!-- ({{ brandPowerDirty[eye] ? "dirty" : "clean" }}) -->
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import RxMethods from "@/assets/js/cls/RxMethods";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
// import RxParser from "@/components/clStuff/RxParser";
import OpticalCrossImage from "@/components/clStuff/OpticalCrossImage";
import AutocompleteAll2 from "@/components/headerStuff/AutocompleteAll-2";
import ApiServices from "@/services/ApiServices";
import RxPaster from "@/components/clStuff/RxPaster.vue";
import RxInput from "@/components/clStuff/RxInput.vue";

// import VertexDistanceInput from "@/components/calcsStuff/VertexDistanceInput.vue";
import VertexAndRoundDialog from "@/components/calcsStuff/VertexAndRoundDialog.vue";

export default {
  name: "ObliqueCrossCyl",
  props: {},
  components: {
    // RxInput,
    // RxParser,
    OpticalCrossImage,
    AutocompleteAll2,
    TrialSuggestionCard: () =>
      import("@/components/clStuff/TrialSuggestionCard"),
    ClPowerDialog: () => import("@/components/clStuff/ClPowerDialog"),
    RxPaster,
    RxInput,

    // VertexDistanceInput,
    VertexAndRoundDialog,
  },
  mixins: [
    RxMethods,
    FiltersMixin,
    // FilterDictionary
  ],
  data: function () {
    return {
      rxObjects: { od: null, os: null },
      clObjects: { od: null, os: null },
      //   rxString: { od: null, os: null },
      //   clString: { od: null, os: null },
      resultRx: { od: null, os: null },
      rotation: { od: 0, os: 0 },
      round: 0.25,
      clBrandObj: { od: null, os: null },
      clBrandPowerObj: { od: null, os: null },
      imgPath: "https://www.eyedock.com/modules/Lenses/pnimages/lens_images/",
      loadingBrandPowers: { od: null, os: null },
      brandPowerDirty: { od: false, os: false },
      vertexDistance: 0.012,
    };
  },
  methods: {
    pasted(event) {
      if (event.cl) this.parserChange(event.cl, "cl");
      if (event.or) this.parserChange(event.or, "rx");
    },
    parserChange(objects, clOrRx) {
      if (!objects) objects = { od: null, os: null };
      if (!objects.od) objects.od = null;
      if (!objects.os) objects.os = null;
      if (clOrRx == "rx") this.rxObjects = objects;
      if (clOrRx == "cl") this.clObjects = objects;
    },
    rotationChange(eye, rotation) {
      this.rotation[eye] = rotation;
      this.setResult(eye);
      this.brandPowerDirty[eye] = true;
    },
    setResult() {
      let resultRx = {};
      ["od", "os"].forEach((eye) => {
        resultRx[eye] = this.addRx(
          this.clObjects[eye],
          this.vertexedOR[eye],
          this.rotation[eye]
        );
        if (resultRx[eye]) resultRx[eye].vertex = 0;
      });
      this.resultRx = resultRx;
    },
    updateClBrand(obj, eye) {
      this.clBrandObj[eye] = obj;
      this.callPowerApi(eye);
    },
    clearForm() {
      // let result = confirm("Are you sure you want to clear this form?");
      // if (result) {
      this.rxObjects = { od: null, os: null };
      this.clObjects = { od: null, os: null };
      this.rotation = { od: null, os: null };
      // }
    },
    callPowerApi(eye) {
      if (!this.resultRx[eye]) return;
      this.loadingBrandPowers[eye] = true;
      let rxParamString = this.rxHash(this.resultRx[eye]); // + "&vertex=0";
      // console.log(this.resultRx[eye]);
      // console.log(rxParamString);
      // todo - make this not vertex the refraction
      ApiServices.bestPowerForLensIdAPI(
        this.clBrandObj[eye].itemId,
        rxParamString
      )
        .then((response) => {
          this.clBrandPowerObj[eye] = response.data;
          this.loadingBrandPowers[eye] = false;
          this.brandPowerDirty[eye] = false;
        })
        .catch((e) => {
          // alert(e);
          console.log("Error loading lens power data");
          console.log(e);
          this.loadingBrandPowers[eye] = false;
        });
    },
    otherEye(eye) {
      return eye == "od" ? "os" : "od";
    },
  },
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly;
    },
    maxWidth: function () {
      let rtn = "1000";
      let bp = this.$vuetify.breakpoint.name;
      if (bp == "sm") rtn = "45%";
      if (bp == "xs") rtn = "100%";
      return rtn;
    },
    eyeCardStyle: function () {
      let rtn = "max-width:1008px; ";
      let bp = this.$vuetify.breakpoint.name;
      if (bp == "sm") rtn += "width:calc(50% - 30px)";
      if (bp == "xs") rtn += "width:100%";
      return rtn;
    },
    vertexedOR: function () {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        if (this.rxObjects[eye])
          rtn[eye] = this.diffVertex(
            this.rxObjects[eye],
            0,
            this.vertexDistance
          );
      });
      return rtn;
    },
    clStrings: function () {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        if (this.clObjects[eye])
          rtn[eye] = this.prettyString(this.clObjects[eye]);
      });
      return rtn;
    },
    rxStrings: function () {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        if (this.rxObjects[eye])
          rtn[eye] = this.prettyString(this.rxObjects[eye]);
      });
      return rtn;
    },
  },
  watch: {
    rxObjects: {
      handler: "setResult",
      deep: true,
    },
    clObjects: {
      handler: "setResult",
      deep: true,
    },
    vertexDistance: {
      handler: "setResult",
    },
    resultRx: {
      handler: function (val, old) {
        ["od", "os"].forEach((eye) => {
          const change = JSON.stringify(val[eye]) === JSON.stringify(old[eye]);
          if (change) {
            // console.log("change");
            this.brandPowerDirty[eye] = true;
          }
        });
      },
      deep: true,
    },
  },
  metaInfo() {
    return {
      title: "EyeDock/Calcs | Oblique Cross Cylinders",
    };
  },
  mounted() {
    // this.resultRx = { od: this.newRxObject(), os: this.newRxObject() };
    let hashParts = this.hashParts();
    let rxObjects = this.rxsFromHash(hashParts);
    let clObjects = this.rxsFromHash(hashParts, "cl");
    this.parserChange(clObjects, "cl");
    this.parserChange(rxObjects, "rx");
  },
};
</script>

<style scoped>
/* .sideways {
  margin: 100px -35px;
  transform: rotate(-90deg);
  width: 100px;
  text-align: center;
  text-align: center;
} */
/* .transparentCard {
  background-color: #ffffff3d !important;

  margin: 5px 0.5em;
  min-width: 235px;
} */
.cardLabel {
  /* font-weight: bold; */
  color: #212121;
  border-bottom: 1px solid #d4d4d4;
  background-color: #ffffff7a;
}
.resultText {
  font-weight: bold;
  /* font-size: larger; */
  padding: 7px;
  letter-spacing: 1.3px;
  color: #2e2e2e;
}
.transparentCard {
  background-color: #ffffff3d !important;
  margin: 5px 0.5em;
  min-width: 235px;
  border: #00000080;
  /* min-height: 275px; */
}
.transparentCard_mobile {
  background-color: transparent !important;
  margin: 2px auto;
  width: 100%;
  padding: 0 0 15px;
}
</style>
